export class Template {
    public static createElement(
        name: string, props: Object, children?: HTMLElement[] | HTMLElement | string,
    ): HTMLElement {
        const element = document.createElement(name);

        if (children !== undefined) {
            if (children instanceof HTMLElement) {
                element.appendChild(children);
            } else if (Array.isArray(children)) {
                children.forEach((c) => element.appendChild(c));
            } else {
                element.appendChild(document.createTextNode(children));
            }
        }

        this._attachProps(element, props);

        return element;
    }

    private static _attachProps(element: HTMLElement, props: Object): void {
        const entries = Object.entries(props);

        for (const [key, value] of entries) {
            let newValue = value;
            if (Array.isArray(value)) {
                newValue = value.join(' ');
            }
            element.setAttribute(key, newValue);
        }
    }
}
